// src/pages/ClientData/components/MovementsTable.js
import React, { useState } from 'react';
import { getOneDriveDownloadUrl } from '../api';
import FileActionsMenu from './FileActionsMenu';

const COLUMN_COUNT = 7;

const MovementsTable = ({
  processCode,
  movimentos,
  movementFiles,
  movementFilesLoading,
  movementFilesErrors,
  onLoadFiles,
  fileTranscriptions,
  fileTranscriptionLoading,
  fileTranscriptionErrors,
  fileSaving,
  onSetFileTranscriptionText,
  onTranscreverFicheiro,
  onSalvarFicheiro
}) => {
  const [expandedRefs, setExpandedRefs] = useState(() => new Set());

  const toggleFicheiros = (referencia) => {
    const chave = `${processCode}::${referencia}`;
    const jaExpandido = expandedRefs.has(referencia);

    setExpandedRefs((prev) => {
      const proximo = new Set(prev);
      if (jaExpandido) {
        proximo.delete(referencia);
      } else {
        proximo.add(referencia);
      }
      return proximo;
    });

    if (!jaExpandido && !movementFiles?.[chave]) {
      onLoadFiles(processCode, referencia);
    }
  };

  const handleDownload = async (ficheiro) => {
    try {
      const response = await getOneDriveDownloadUrl(ficheiro.Caminho);
      if (response.data.success && response.data.downloadUrl) {
        window.open(response.data.downloadUrl, '_blank', 'noopener,noreferrer');
      } else {
        alert(response.data.message || 'Não foi possível obter o ficheiro do OneDrive');
      }
    } catch (error) {
      alert(error.response?.data?.message || 'Erro ao obter o ficheiro do OneDrive');
    }
  };

  return (
    <table className="cd-movements-table">
      <thead>
        <tr>
          <th>Referência</th>
          <th>Data</th>
          <th>Acto</th>
          <th>Destino</th>
          <th>Interveniente</th>
          <th>Qualidade</th>
          <th>Ficheiros</th>
        </tr>
      </thead>
      <tbody>
        {movimentos.map((movimento) => {
          const referencia = movimento['Referência'];
          const chave = `${processCode}::${referencia}`;
          const expandido = expandedRefs.has(referencia);
          const ficheiros = movementFiles?.[chave];
          const carregandoFicheiros = movementFilesLoading?.[chave];
          const erroFicheiros = movementFilesErrors?.[chave];

          return (
            <React.Fragment key={referencia}>
              <tr>
                <td>{referencia}</td>
                <td>{movimento['Data']}</td>
                <td>{movimento['Acto']}</td>
                <td>{movimento['Destino']?.trim() || '-'}</td>
                <td>{movimento['Interveniente']?.trim() || '-'}</td>
                <td>{movimento['Qualidade']?.trim() || '-'}</td>
                <td>
                  <button
                    type="button"
                    className="cd-icon-btn"
                    title={expandido ? 'Ocultar ficheiros' : 'Carregar ficheiros'}
                    onClick={() => toggleFicheiros(referencia)}
                  >
                    📎
                  </button>
                </td>
              </tr>
              {expandido && (
                <tr className="cd-movement-files-row">
                  <td colSpan={COLUMN_COUNT}>
                    {carregandoFicheiros && <div className="cd-inline-loading">⏳ A carregar ficheiros...</div>}
                    {erroFicheiros && <div className="error-message">{erroFicheiros}</div>}
                    {!carregandoFicheiros && ficheiros && (
                      <table className="cd-files-table">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Nome</th>
                            <th>Caminho</th>
                            <th>Transcrição</th>
                            <th>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(ficheiros.Ficheiros || []).map((ficheiro) => {
                            const chaveTranscricao = `${chave}::${ficheiro.ID}`;
                            const transcrevendo = Boolean(fileTranscriptionLoading?.[chaveTranscricao]);
                            const guardando = Boolean(fileSaving?.[chaveTranscricao]);
                            const erroTranscricao = fileTranscriptionErrors?.[chaveTranscricao];
                            const textoTranscricao = fileTranscriptions?.[chaveTranscricao] || '';

                            return (
                              <tr key={ficheiro.ID}>
                                <td>{ficheiro.ID}</td>
                                <td>{ficheiro.Nome}</td>
                                <td className="cd-file-path">{ficheiro.Caminho}</td>
                                <td>
                                  <textarea
                                    className="cd-transcription-box"
                                    rows={3}
                                    placeholder={transcrevendo ? 'A transcrever...' : 'Sem transcrição'}
                                    value={textoTranscricao}
                                    onChange={(e) => onSetFileTranscriptionText(chaveTranscricao, e.target.value)}
                                    disabled={transcrevendo}
                                  />
                                  {erroTranscricao && <div className="error-message">{erroTranscricao}</div>}
                                </td>
                                <td>
                                  <FileActionsMenu
                                    onDownload={() => handleDownload(ficheiro)}
                                    onTranscrever={() => onTranscreverFicheiro(processCode, referencia, ficheiro)}
                                    onGuardar={async () => {
                                      const resultado = await onSalvarFicheiro(processCode, referencia, ficheiro);
                                      if (resultado.success) {
                                        alert('Ficheiro guardado em Meus Documentos!');
                                      } else {
                                        alert(resultado.message || 'Erro ao guardar ficheiro');
                                      }
                                    }}
                                    transcrevendo={transcrevendo}
                                    guardando={guardando}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                          {(!ficheiros.Ficheiros || ficheiros.Ficheiros.length === 0) && (
                            <tr>
                              <td colSpan={5}>Sem ficheiros associados a este movimento</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </td>
                </tr>
              )}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  );
};

export default MovementsTable;
